import PhoneInputImport from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useThemeContext } from "../../globalContext/global-context";
import type { QuestionViewProps } from "../contracts";
import type { PhoneDefinition, PhoneDraft, PhoneEvent } from "./core";

type PhoneInputComponentType = React.ComponentType<Record<string, unknown>>;

const PhoneInputComponent =
  (PhoneInputImport as unknown as { default?: PhoneInputComponentType })
    .default ?? (PhoneInputImport as unknown as PhoneInputComponentType);

export const PhoneView = ({
  definition,
  draft,
  dispatch,
  controls,
}: QuestionViewProps<PhoneDefinition, PhoneDraft, PhoneEvent>) => {
  const { globalObject } = useThemeContext();
  const theme = globalObject.themeData.normalizedTheme;
  return (
    <>
      <PhoneInputComponent
        country={definition.country}
        specialLabel={theme.copy.phone.label}
        placeholder={theme.copy.phone.placeholder}
        searchPlaceholder={theme.copy.phone.search}
        searchNotFound={theme.copy.phone.noResults}
        localization={theme.copy.phone.countryNames}
        value={draft.value}
        onChange={(value: string) => dispatch({ type: "set-value", value })}
        inputProps={{
          name: "phone",
          "aria-label": theme.copy.labels.phoneNumber,
          "data-testid": "phone-input-field",
          inputMode: "tel",
          autoFocus: true,
          onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter" && !event.nativeEvent.isComposing) {
              event.preventDefault();
              controls.primaryAction?.run();
            }
          },
        }}
        inputStyle={{
          width: "100%",
          minHeight: "35px",
          fontFamily: theme.tokens.typography.fontFamily,
          fontSize: `${theme.tokens.typography.size.md}px`,
          fontWeight: theme.tokens.typography.weight.regular,
          border: 0,
          borderRadius: `${theme.tokens.shape.radius.md}px`,
        }}
        buttonStyle={{
          border: 0,
          borderRight: `1px solid ${theme.tokens.color.action.primary}`,
          borderRadius: `${theme.tokens.shape.radius.md}px 0 0 ${theme.tokens.shape.radius.md}px`,
        }}
        dropdownStyle={{ position: "absolute", bottom: 0 }}
      />
    </>
  );
};
